import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MinorEditsService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/minor-edits`;

  constructor(private http: HttpClient) { }

  hasOpenWorkflow(customerId: number, websiteUrlId: number): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/has-open-workflow`, { params: { customerId, websiteUrlId } });
  }

  order(customerId: number, description: string, websiteUrlId: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}`, {
      customerId,
      websiteUrlId,
      description
    });
  }
}
